import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { DeliveryServiceService } from 'src/app/shared/services/delivery-service.service';
import {
  deleteDeliveryService,
  editDeliveryService,
  loadDeliveryService,
  loadDeliveryServiceSuccess,
  saveDeliveryService,
} from './delivery-service.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class DeliveryServiceEffects {
  constructor(
    private service: DeliveryServiceService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadDeliveryService$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadDeliveryService),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadDeliveryServiceSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveDeliveryService$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveDeliveryService),
      concatMap(({ deliveryService }) =>
        this.service.save(deliveryService).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadDeliveryService()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editDeliveryService$ = createEffect(() =>
    this.action$.pipe(
      ofType(editDeliveryService),
      concatMap(({ deliveryService, id }) =>
        this.service.edit(deliveryService, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadDeliveryService()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteDeliveryService$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteDeliveryService),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadDeliveryService()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
